module.exports = __webpack_public_path__ + "img/组5394@2x.29d86b6e.png";